module.exports = __webpack_public_path__ + "static/media/Background.5e92c890.jpg";